import React, { memo } from 'react';
import Accordion from '../../../shared/components/Accordion';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import PropTypes from 'prop-types';

const QuestionsSection = memo(({ id, title, data }) => {
  const collapsible = data.map(question => ({
    content: <span dangerouslySetInnerHTML={{__html: question.answer}}></span>,
    header: question.question,
    code: question.code
  }));
  return (
    <section id={id} className="auto-padding-section mb-6">
      <ResponsiveHeader className='mb-4' xs='h4' md='h3'>
        {title}
      </ResponsiveHeader>
      <Accordion
        collapsibles={collapsible}>
      </Accordion>
    </section>
  );
}
);

QuestionsSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.array,
};
QuestionsSection.defaultProps = {
  data: []
};
export default QuestionsSection;